// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getPreferredAddress } from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.selectors';
import { getProfileInfoTileData } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { AFTERPAY_REDUCER_KEY } from '../../../../../constants/reducer.constants';

export const getAfterPayStatus = (state) => {
  return (state[AFTERPAY_REDUCER_KEY] && state[AFTERPAY_REDUCER_KEY].status) || false;
};

export const getAfterPayTokens = (state) => {
  return (state[AFTERPAY_REDUCER_KEY] && state[AFTERPAY_REDUCER_KEY].tokens) || '';
};

export const getFallbackAddress = createSelector(
  getPreferredAddress,
  getProfileInfoTileData,
  (defaultAddress, userAddress) => {
    const addressObj = {
      addressLine1: '',
      addressLine2: '',
      city: '',
      country: 'US',
      firstName: '',
      lastName: '',
      state: '',
      zipCode: '',
      addressId: '',
    };
    if (userAddress) {
      addressObj.addressLine1 = userAddress?.address?.addressLine1;
      addressObj.addressLine2 = userAddress?.address?.addressLine2;
      addressObj.city = userAddress?.address?.city;
      addressObj.country = userAddress?.address?.country;
      addressObj.firstName = userAddress.firstName;
      addressObj.lastName = userAddress.lastName;
      addressObj.state = userAddress?.address?.state;
      addressObj.zipCode = userAddress?.address?.zipCode;
      addressObj.addressId = userAddress?.address?.addressId;
    }
    if (defaultAddress) {
      addressObj.addressLine1 = defaultAddress.address1;
      addressObj.addressLine2 = defaultAddress.address2;
      addressObj.city = defaultAddress.city;
      addressObj.country = defaultAddress.countryCode;
      addressObj.firstName = defaultAddress.firstName;
      addressObj.lastName = defaultAddress.lastName;
      addressObj.state = defaultAddress.stateCode;
      addressObj.zipCode = defaultAddress.postalCode;
      addressObj.addressId = defaultAddress.addressId;
    }
    return addressObj;
  }
);

export const getFallbackUserInfo = createSelector(
  getPreferredAddress,
  getProfileInfoTileData,
  (defaultAddress, userAddress) => {
    const addressObj = {};
    if (userAddress) {
      addressObj.emailAddress = userAddress.emailAddress;
      addressObj.phoneNumber = userAddress.phoneNumber;
      addressObj.firstName = userAddress.firstName;
      addressObj.lastName = userAddress.lastName;
    }
    if (defaultAddress) {
      addressObj.emailAddress = defaultAddress.c_emailId;
      addressObj.phoneNumber = defaultAddress.phone;
      addressObj.firstName = defaultAddress.firstName;
      addressObj.lastName = defaultAddress.lastName;
    }
    return addressObj;
  }
);
